import { Button } from '@mui/material';
import { Link } from 'react-router';

import { ChargingModel } from 'modules/billing/types';
import { GetPremiumButton } from 'modules/billing/components/GetPremiumButton';
import { billingRoutesConfig } from 'domains/account/routes';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { buttonsTranslation } from './translation';
import { useButtonsStyles } from './useButtonsStyles';

const billingPage = billingRoutesConfig.billing.path;

export interface ButtonsProps {
  chargingModel: ChargingModel | undefined;
  onButtonClick?: () => void;
}

export const Buttons = ({ chargingModel, onButtonClick }: ButtonsProps) => {
  const { classes } = useButtonsStyles();
  const { keys, t } = useTranslation(buttonsTranslation);

  return (
    <div className={classes.root}>
      <Button
        component={Link}
        fullWidth
        onClick={onButtonClick}
        size="small"
        to={billingPage}
        variant="outlined"
      >
        {t(keys.manage)}
      </Button>
      {chargingModel?.type === 'freemium' && (
        <GetPremiumButton fullWidth onClick={onButtonClick} />
      )}
    </div>
  );
};
